import { createContext } from 'react';

import type { NotificationCallback, GPAgentResponseCallback } from '../../types';

export type CentrifugoContextType = {
  onDialogueUpdated: (callback: NotificationCallback) => () => void;
  onActivitiesUpdated: (callback: NotificationCallback) => () => void;
  /** Subscribe to a specific customer channel. Returns unsubscribe function. */
  subscribeToCustomer: (customerId: number) => () => void;
  /** Subscribe to AI agent response notifications for a staff member. Returns unsubscribe function. */
  subscribeToStaffChannel: (staffId: number, callback: GPAgentResponseCallback) => () => void;
  isConnected: boolean;
};

// eslint-disable-next-line no-empty-function
const noop = () => {};

const defaultValue: CentrifugoContextType = {
  onDialogueUpdated: () => noop,
  onActivitiesUpdated: () => noop,
  subscribeToCustomer: () => noop,
  subscribeToStaffChannel: () => noop,
  isConnected: false,
};

export const CentrifugoContext = createContext<CentrifugoContextType | null>(defaultValue);
